import * as tslib_1 from "tslib";
import datapoints from '../datapoints';
import getUserConfiguration from 'owa-session-store/lib/actions/getUserConfiguration';
import getWeatherForecastService from '../services/getWeatherForecastService';
import store from '../store/store';
import { action, select } from 'satcheljs/lib/legacy';
var addWeatherDailyConditionsToStore = action('addWeatherDailyConditionsToStore')(function addWeatherDailyConditionsToStore(weatherDailyConditions, weatherForecastResponse) {
    if (weatherDailyConditions && weatherForecastResponse) {
        // Clear array, instead of constructing a new one.
        weatherDailyConditions.length = 0;
        var currentLocation = weatherForecastResponse.WeatherLocations[0];
        weatherDailyConditions.push(currentLocation.Conditions); // Weather right now.
        store.weatherClickThrough = currentLocation.ClickThrough;
        currentLocation.MultidayForecast.DailyForecasts.forEach(function (item) {
            weatherDailyConditions.push(item); // Weather for the following days.
        });
    }
});
export default action('loadWeatherForecast', datapoints.loadWeatherForecast)(select({
    weatherDailyConditions: function () { return store.weatherDailyConditions; },
    weatherLocations: function () { return getUserConfiguration().UserOptions.WeatherLocations; },
    weatherUnit: function () { return getUserConfiguration().UserOptions.WeatherUnit; },
})(function loadWeatherForecast(state) {
    return tslib_1.__awaiter(this, void 0, void 0, function () {
        var locations_1, weatherForecastResponse;
        return tslib_1.__generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    if (!(state.weatherLocations && state.weatherLocations.length > 0)) return [3 /*break*/, 2];
                    locations_1 = [];
                    state.weatherLocations.forEach(function (loc) {
                        locations_1.push({
                            EntityId: loc.LocationId,
                            Name: loc.Name,
                            Latitude: loc.Latitude ? parseFloat(loc.Latitude) : 0,
                            Longitude: loc.Longitude ? parseFloat(loc.Longitude) : 0,
                        });
                    });
                    return [4 /*yield*/, getWeatherForecastService(locations_1, state.weatherUnit)];
                case 1:
                    weatherForecastResponse = _a.sent();
                    addWeatherDailyConditionsToStore(state.weatherDailyConditions, weatherForecastResponse);
                    _a.label = 2;
                case 2: return [2 /*return*/];
            }
        });
    });
}));
//# sourceMappingURL=loadWeatherForecast.js.map